import styled from '@emotion/styled';

import type { ButtonProps } from '@hotjar/webapp/components/Button';
import { Icon } from '@hotjar/webapp/components/Icon';
import { tokens } from '@hotjar/hotsauce';

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ButtonIconContainer = styled.span`
  position: relative;
  background-color: ${tokens.color.ui_background};
`;

export const ButtonText = styled.span`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const StyledButtonWithIcon = styled.button`
  border-radius: ${tokens.radius.m};
  border: 1px solid transparent;
  outline: none;
  color: ${tokens.color.white};
  font-size: 13px;
  font-weight: 600;
  font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  letter-spacing: 0.2px;
  cursor: pointer;
  white-space: nowrap;

  &:active,
  &.active {
    ${tokens.elevation(-1)};
  }

  &[disabled] {
    opacity: 0.2;
    pointer-events: auto;
  }

  display: inline-flex;
  padding: 0;
  overflow: hidden;
  align-items: center;
  background-color: ${tokens.color.neutral_700};
  text-transform: none;
  width: 100%;

  &:hover,
  &:focus,
  &:active,
  &.active {
    background: ${tokens.color.neutral_800};
    color: ${tokens.color.white};
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.22);
  }

  ${ButtonIconContainer} {
    display: block;
    height: 63px;
    width: 63px;
  }

  ${ButtonText} {
    font-size: 16px;
  }
`;

export const SamlSsoButton = ({ children, ...props }: ButtonProps): JSX.Element => {
  return (
    <StyledButtonWithIcon {...props}>
      <ButtonIconContainer>
        <StyledIcon icon="lock" size={24} color={tokens.color.neutral_600} />
      </ButtonIconContainer>
      <ButtonText>{children}</ButtonText>
    </StyledButtonWithIcon>
  );
};
